class Controller {
  constructor() {
    "ngInject";
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/quickview/quickview.controller.js